// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --toolbar-size: 56px;
  --border-style: solid;
  display: grid;
  grid-template: "buttons navigation logo" auto/1fr 2fr 1fr;
  min-height: var(--toolbar-size);
  max-height: var(--toolbar-size);
  min-width: 100%;
  max-width: 100%;
  text-align: center;
  border-color: var(--color-blue);
  border-width: var(--border-width-thin);
  border-bottom-style: var(--border-style);
}

:host-context(.dark-theme) {
  border-color: var(--color-white);
}

.buttons-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-medium);
  margin-left: var(--spacing-medium);
}

button[mat-mini-fab] {
  width: 28px;
  height: 28px;
}
button[mat-mini-fab] mat-icon {
  font-size: var(--font-size-medium);
}

button[mat-mini-fab].active {
  --mdc-fab-small-container-color: var(--color-teal);
}

.selected-language {
  color: var(--color-teal);
}

.navigation {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
}
.navigation a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px var(--spacing-medium) 0;
  border-bottom: 4px solid transparent;
  text-decoration: none;
  font-weight: bold;
  color: var(--color-blue);
}
.navigation a.selected {
  color: var(--color-teal);
  border-color: var(--color-teal);
}
.navigation a:hover {
  background-color: var(--color-teal-transparent);
}

:host-context(.dark-theme) .navigation a:not(.selected) {
  color: var(--color-white);
}

.logo-wrapper {
  grid-area: logo;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-medium);
}

.logo {
  height: 100%;
  width: 48px;
  margin: 0 var(--spacing-small);
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/toolbar/toolbar.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA;EAEA,aAAA;EACA,yDAAA;EACA,+BAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,sCAAA;EACA,wCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,kCAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;AAEE;EACE,kCAAA;AAAJ;;AAIA;EACE,kDAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,oCAAA;EACA,oCAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;AAFJ;AAKE;EACE,wBAAA;EACA,+BAAA;AAHJ;AAME;EACE,+CAAA;AAJJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AALF;;AAQA;EACE,YAAA;EACA,WAAA;EACA,8BAAA;AALF","sourcesContent":[":host {\n  --toolbar-size: 56px;\n  --border-style: solid;\n\n  display: grid;\n  grid-template: \"buttons navigation logo\" auto / 1fr 2fr 1fr;\n  min-height: var(--toolbar-size);\n  max-height: var(--toolbar-size);\n  min-width: 100%;\n  max-width: 100%;\n  text-align: center;\n  border-color: var(--color-blue);\n  border-width: var(--border-width-thin);\n  border-bottom-style: var(--border-style);\n}\n\n:host-context(.dark-theme) {\n  border-color: var(--color-white);\n}\n\n.buttons-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-medium);\n  margin-left: var(--spacing-medium);\n}\n\nbutton[mat-mini-fab] {\n  width: 28px;\n  height: 28px;\n\n  mat-icon {\n    font-size: var(--font-size-medium);\n  }\n}\n\nbutton[mat-mini-fab].active {\n  --mdc-fab-small-container-color: var(--color-teal);\n}\n\n.selected-language {\n  color: var(--color-teal);\n}\n\n.navigation {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n\n  a {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    padding: 4px var(--spacing-medium) 0;\n    border-bottom: 4px solid transparent;\n    text-decoration: none;\n    font-weight: bold;\n    color: var(--color-blue);\n  }\n\n  a.selected {\n    color: var(--color-teal);\n    border-color: var(--color-teal);\n  }\n\n  a:hover {\n    background-color: var(--color-teal-transparent);\n  }\n}\n\n:host-context(.dark-theme) .navigation a:not(.selected) {\n    color: var(--color-white);\n}\n\n.logo-wrapper {\n  grid-area: logo;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-medium);\n}\n\n.logo {\n  height: 100%;\n  width: 48px;\n  margin: 0 var(--spacing-small);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
